import { createApp } from "vue";
import GlyphBlock from "../apps/GlyphBlock.vue";

export default () => {
  // Add unique method to Array prototype
  Array.prototype.unique = function () {
    return this.filter((value, index, self) => self.indexOf(value) === index);
  };

  // Add last method to Array prototype if it doesn't exist
  if (!Array.prototype.last) {
    Array.prototype.last = function () {
      return this[this.length - 1];
    };
  }

  let newApp = document.querySelectorAll("#glyph-block");

  newApp.forEach((element) => {
    const fontChoice = element.getAttribute("data-font");
    createApp(GlyphBlock, { fonts: fontChoice }).mount(element);
  });
};